export function openDecagonChat() {
  if (window.duet) {
    window.duet.open();
  }
}

export function prepopulateDecagonMessage(message) {
  const iframe = document.querySelector('iframe[src*="decagon.ai"]');

  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        initialUserMessage: message,
      },
      'https://decagon.ai'
    );
  }
}
